/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import lightGallery from 'lightgallery'


// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

//import Swiper, { Navigation, Pagination } from 'swiper'
import {
	setHrefs
} from './functions/data-hrefs'
import {
	initEqualizeContent
} from './functions/equalizer'
import {
	initTelephoneInput
} from './functions/intl-tel-input'
import {
	initDatepickerInput
} from './functions/datepicker'
import {
	enableNegativeMargins
} from './functions/negative-margins'
import {
	mapStyles
} from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/american_steel_inc_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
//Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

	// jQuery('.tab-in-page-links').on('click', function (e) {
	// 	e.preventDefault();

	// 	const targetTab = jQuery(this).data('tab');
	// 	const targetSection = jQuery(this).data('section');

	// 	const tabLink = jQuery('a[href="#' + targetTab + '"]');
	// 	if (tabLink.length) {
	// 		tabLink.trigger('click');
	// 	}

	// 	setTimeout(function () {
	// 		const sectionEl = jQuery('#' + targetSection);
	// 		if (sectionEl.length) {
	// 			jQuery('html, body').animate({
	// 				scrollTop: sectionEl.offset().top - 150
	// 			}, 600);
	// 		}
	// 	}, 400);
	// });


	jQuery(document).ready(function ($) {
		$('.tab-in-page-links').on('click', function (e) {
			e.preventDefault();
	
			const targetTab = $(this).data('tab');
			const targetSection = $(this).data('section');
	
			const tabLink = $('a[href="#' + targetTab + '"]');
			if (tabLink.length) {
				// Listen once for Foundation's tab change completion
				$(document).one('change.zf.tabs', function () {
					const sectionEl = $('#' + targetSection);
					if (sectionEl.length) {
						$('html, body').animate({
							scrollTop: sectionEl.offset().top - 150
						}, 600);
					}
				});
	
				// Trigger the tab change
				tabLink.trigger('click');
			}
		});
	});
	

	jQuery('#offCanvas-product').removeClass('hide');


	// function switchTabAndScroll(tabId, sectionId) {
	// 	document.querySelector(`[href="#${tabId}"]`).click();
	// 	setTimeout(function() {
	// 		jQuery('html, body').animate({
	// 			scrollTop: jQuery(`#${sectionId}`).offset().top - 300
	// 		}, 'slow');
	// 	}, 300);
	// }


	jQuery('.tabs .tabs-title').on('click', function () {
		var childIndex = jQuery(this).index()
		var linePosition = jQuery(this).outerWidth() * childIndex;
		jQuery(this).parent().find('.tabs-underline').css('transform', 'translateX(' + linePosition + 'px)');
	});

	jQuery('.menu-item-21377').on('click', function (event) {
		if (jQuery(window).width() >= 640) {
			event.preventDefault();
		}
		jQuery('.productDropdown').slideToggle();
		jQuery(this).toggleClass('is-open');
		jQuery('#content').toggleClass('darkOverlay'); 
		
	});

	jQuery(document).click(function(e){
		if((jQuery(e.target).closest(".menu-item-21377").length===0) && (jQuery(e.target).closest(".productDropdown").length===0)){
			jQuery(".productDropdown").hide('slide');
			jQuery('#content').removeClass('darkOverlay');
			jQuery(this).removeClass('is-open');

		};
	});

	// $(document).click(function (e) {
	// 	var target = e.target;
	// 	if (!$(target).is('.dropdown-toggle') && !$(target).parents().is('.dropdown-toggle'))
	// 	//{ $('.dropdown').hide(); }
	// 	{
	// 		$('.dropdown').slideUp();
	// 	}
	// });

	let $lgSwiper = document.getElementById('lg-swipper');

	var mainImagesSwiper = new Swiper(".galley-product-swiper", {

		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		slidesPerColumnFill: 'row',

		// navigation: {
		//   nextEl: ".swiper-button-next",
		//   prevEl: ".swiper-button-prev",
		// },

		// pagination: {
		//     el: '.serviceSwiper .swiper-pagination',
		//     clickable: true,
		// },



		breakpoints: {
			640: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1024: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1440: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
		},

		on: {
			init: function () {
				const lg = lightGallery($lgSwiper, {
					// selector: '.swiper-slide',
					plugins: [lgThumbnail],
					licenseKey: 'B42122F4-AE41-435C-BA3A-91BFC685EE99',
					speed: 500,
				});

				// Before closing lightGallery, make sure swiper slide
				// is aligned with the lightGallery active slide
				$lgSwiper.addEventListener('lgBeforeClose', () => {
					mainImagesSwiper.slideTo(lg.index, 0)
				});
			}
		}

	});

	var thumbnailsSwiper = new Swiper(".galley-product-thumbs-swiper", {

		direction: "vertical",
		//spaceBetween: 20,
		autoHeight: true,
		loop: false,
		slidesPerView: 4,
		//slidesPerColumn: 1, 
		// slidesPerColumnFill: 'row',

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		// pagination: {
		//     el: '.serviceSwiper .swiper-pagination',
		//     clickable: true,
		// },




	});


	thumbnailsSwiper.on('click', function () {
		var clickedIndex = thumbnailsSwiper.clickedIndex;
		if (clickedIndex !== undefined) {
			mainImagesSwiper.slideTo(clickedIndex);
		}
	});

	mainImagesSwiper.on('slideChange', function () {
		var activeIndex = mainImagesSwiper.activeIndex;
		thumbnailsSwiper.slideTo(activeIndex);
	});


	var mainImagesSwiper = new Swiper(".photos-swiper", {

		direction: 'horizontal',
		spaceBetween: 30,
		slidesPerView: 1,
		slidesPerColumn: 1,
		//initialSlide: 1,
		watchSlidesProgress: true,
		observeParents: true,
		//slidesPerColumnFill: 'row',
		pagination: {
			el: '.photos-swiper-pagination',
			clickable: true,
		},

		breakpoints: {
			640: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1024: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
			1440: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
		},

	});

	if(jQuery('#anniversary-section_2').length){
		jQuery('#anniversary-section_2').append('<div class="timeline-line-active show-for-large"></div>')
		// Update on load
		updateTimelineProgress();
		
		// Update on scroll
		jQuery(window).on('scroll', updateTimelineProgress);
		
		// Update on resize
		jQuery(window).on('resize', updateTimelineProgress);
	}

	function updateTimelineProgress() {
		const timelineSection = jQuery('#anniversary-section_2');
		const timelineLine = jQuery('.timeline-line-active');
		
		// Get the section's position and dimensions
		const sectionRect = timelineSection[0].getBoundingClientRect();
		const sectionHeight = sectionRect.height;
		
		// Get the timeline line's position and dimensions
		const timelineRect = timelineLine[0].getBoundingClientRect();
		const timelineHeight = timelineRect.height;
		
		// Calculate viewport middle point
		const viewportMiddle = window.innerHeight / 2;
		
		// Calculate 50% of viewport height (maximum height for pseudo-element)
		const maxHeight = window.innerHeight * 0.5;
		
		// Check if timeline section is visible
		if (sectionRect.top < window.innerHeight && sectionRect.bottom > 0) {
			// Calculate the position of the section relative to the middle of the screen
			const distanceToMiddle = viewportMiddle - sectionRect.top;
			
			// Start showing the pseudo-element when the section reaches the middle of the screen
			if (distanceToMiddle > 0) {
				// Calculate how much of the section has passed the middle point
				let progress = distanceToMiddle / sectionHeight;
				progress = Math.max(0, Math.min(1, progress));
				
				// Calculate the height of the pseudo-element
				let pseudoHeight = timelineHeight * progress;
				pseudoHeight = Math.min(pseudoHeight, maxHeight);
				
				// Determine the top position of the pseudo-element
				let topPosition = 0;
				
				// If the timeline extends above the viewport
				if (timelineRect.top < 0) {
					// Adjust the top position to keep the pseudo-element aligned with the viewport middle
					topPosition = Math.abs(timelineRect.top);
					
					// Ensure the pseudo-element doesn't exceed the timeline height
					pseudoHeight = Math.min(pseudoHeight, timelineHeight - topPosition);
				}
				
				// Update the CSS variables directly on the timeline-line element
				timelineLine[0].style.setProperty('--pseudo-height', `${pseudoHeight}px`);
				timelineLine[0].style.setProperty('--pseudo-top', `${topPosition}px`);
			} else {
				// Section hasn't reached the middle of the screen yet
				// Reset the CSS variables
				timelineLine[0].style.setProperty('--pseudo-height', '0px');
				timelineLine[0].style.setProperty('--pseudo-top', '0px');
			}
		} else {
			// Section is not visible
			// Reset the CSS variables
			timelineLine[0].style.setProperty('--pseudo-height', '0px');
			timelineLine[0].style.setProperty('--pseudo-top', '0px');
		}
	}
	

	// document.addEventListener('wpcf7mailsent', function(event) {
	// 	window.location.href = '/thank-you/';
	//   }, false);


});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// PRINT CURRENT YEAR
	jQuery('.copyright-year').html(new Date().getFullYear());

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */